// initial state
const state = {
  storeProduct: {
    price: "--", 
    title: "Loading store ...",
    billingPeriodUnit: "--"
  }
}



// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setStoreProduct(state, product) {
    state.storeProduct = product;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}